<template>
  <div class="comPropertyListCard_container">
		<div class="comPropertyListCard_container_title mb-1" v-if="title || rightLabel">
			<div :class="['title_left' , !rightLabel ? type : '']">
				{{ title }}
			</div>
			<div v-if="rightLabel" :class="['title_right' , type]">
				{{ rightLabel }}
			</div>
		</div>
		<div class="comPropertyListCard_container_list  padding-1">
			<div v-for="(item, index) in showList" :key="index" :class="['list_item' , index == showList.length - 1 ? '' : 'mb-1']">
				<div class="list_item_label">{{item.label}}</div>
				<div class="list_item_title">{{item.title}}</div>
			</div>
		</div>
  </div>	
</template>

<script>
export default {
    name: "ComPropertyListCard",
    props:{
		title: {
			type: String,
			default: ""
		},
		rightLabel:{
			type: String,
			default: ""
		},
		type:{
			type: String,
			default: "info",   // 状态类型，success、warning、error、cancel、info
		},
		showList: { // 数组长度为单数的时候最后一个通栏展示
			type: Array,
			default: () => [{
				title: '2025.02.08 16:15:20111',
				label: '认购时间'
			},{
				title: '200 USDT',
				label: '支付USDT'
			},{
				title: '200 MAXC',
				label: '支付MAXC'
			},{
				title: '80 MAX',
				label: '收益获得MAX'
			},]
		}
	}
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>